var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoffeeMaker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#212831",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M23.305 4.6V3.2c0-1.2-1-2.2-2.2-2.2h-17.7c-1.2 0-2.2 1-2.2 2.2V21c0 1.2 1 2.2 2.2 2.2h17.7c1.2 0 2.2-1 2.2-2.2v-3.3h-14.3V4.5h14.3z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#212831",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.405 10.7h5.8v4c0 1.6-1.3 2.9-2.9 2.9s-3-1.3-3-3v-3.9z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#212831",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M5.105 8.8a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2ZM5.105 15a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212831",
  d: "M17.205 7c-.4 0-.8.3-.8.8s.3.8.8.8.8-.3.8-.8-.3-.8-.8-.8"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.205 0h24v24h-24z"
})))));
export default SvgCoffeeMaker;